import React, { useContext, useState, useEffect } from "react";
import UserExpenseReportRow from "../../components/UserExpenseReportRow";

import { ExpenseReportsContext } from "./../ExpenseReportsContext";
import { Pagination } from "antd";

const columnTitles = [
  "Semaine",
  "Nom",
  "Emetteur",
  "Type de frais",
  "Statut",
  "Date de la demande",
  "Date de la facture",
  "Montant",
  "Infos",
  "PJ",
  "Date de traitement",
  "Actions"
];

const ExpenseReportsList = ({ getRangeRequestParams, getMatchParams, currentPage }) => {
  const { onChangeListPage, expenseReportsList, expenseReportsListData } = useContext(ExpenseReportsContext);
  const [list, setList] = useState(expenseReportsList);

  useEffect(() => {
    setList(expenseReportsList);
  }, [expenseReportsList]);

  return (
    <div className="flex flex-col my-8 mr-6">
      <div className="-my-2 py-2 overflow-x-auto ">
        <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
          <table className="min-w-full">
            <thead>
              <tr>
                {columnTitles.map(columnTitle => (
                  <th
                    index={columnTitle}
                    className="px-2 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider"
                  >
                    <div className="flex justify-between">{columnTitle}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white">
              {list &&
                list.map(expenseReport => (
                  <UserExpenseReportRow
                    currentPage={currentPage}
                    expenseReport={expenseReport}
                    key={expenseReport._id}
                    getRangeRequestParams={getRangeRequestParams}
                    getMatchParams={getMatchParams}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
      {expenseReportsListData && (
        <div className="flex justify-end mt-8">
          <Pagination
            defaultCurrent={expenseReportsListData.page}
            total={expenseReportsListData.total}
            onChange={onChangeListPage}
          />
        </div>
      )}
    </div>
  );
};

export default ExpenseReportsList;



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/expenseReportsList/ExpenseReportsList.js